<script>
	export let data;
	import { isNewDataChanged } from "../../../../stores/variables";
	import { phoneMask } from "../../../../scripts/phone_mask";
	import { cloneDeep } from "lodash-es";

	function remove(i) {
		$isNewDataChanged = true;
		data.phones[i].toDelete = true;
		data.newData.Phone[i]["ToDelete"] = true;
	}

	function restore(i) {
		$isNewDataChanged = true;
		data.phones[i].toDelete = false;
		data.newData.Phone[i]["ToDelete"] = false;
	}

	function add() {
		data.phones = data.phones.concat({
			value: "",
			comment: "",
			id: "0",
		});
	}
	function add2() {
		if (data.phones.length >= 20) {
			return;
		}
		let temp = {
			Phone: "",
			Comment: "",
			ID: "",
		};
		data.newData.Phone[data.newData.Phone.length] = temp;
	}

	if (data) {
		if (!data.phones) {
			data.phones = [
				{
					value: "",
					comment: "",
					id: "",
				},
			];
		}

		if (!data.newData) data.newData = [];
		if (!data.newData.Phone) data.newData.Phone = [];
	}
	$: if (data.newData) {
		if (!Array.isArray(data.newData.Phone))
			data.newData.Phone = Array.from(data.newData.Phone);
		if (data.newData.Phone) {
			data.newData.Phone.forEach((raw, i) => {
				i > 0 &&
					data.phones.length < data.newData.Phone.length &&
					add();
			});
			data.phones.forEach((phone, i) => {
				if (data.newData.Phone[i]) {
					phone.value = data.newData.Phone[i]["Phone"];
					phone.comment = data.newData.Phone[i]["Comment"];
					phone.ID = data.newData.Phone[i]["ID"];
				}
			});
		}
	}
	$: if (
		data.newData &&
		data.newData[data.field_name] &&
		data.newData[data.field_name].length < 1
	) {
		data.newData.Phone[0] = {
			Phone: "",
			Comment: "",
			ID: "",
		};
	}
</script>

{#if data.phones}
	{#if data.name}
		<h3>{data.name}</h3>
	{/if}
	<div class="phone">
		{#each data.phones as element, i}
			<div class="phone__row {data.phones[i].toDelete ? 'deleted' : ''}">
				{#if data.newData.Phone[i]}
					<div class="input__wrap">
						<input
							type="tel"
							bind:value={data.newData.Phone[i]["Phone"]}
							on:input={(e) => {
								data.newData.Phone[i]["Phone"] = phoneMask(
									e.target.value
								);
								$isNewDataChanged = true;
								if (e.target.value.length > 17)
									e.target.classList.remove("invalid");
								if (e.target.value[0] == "8") {
									e.target.pattern = ".{17,}";
								} else if (e.target.value[0] == "+") {
									e.target.pattern = ".{18,}";
								}
							}}
							pattern={".{18,}"}
							required={data.required ? "required" : ""}
							class="phone__phone"
						/>

						<span
							class={data.newData.Phone[i]["Phone"]
								? "active"
								: ""}
							>{i == 0 ? "Основной телефон" : "Телефон"}</span
						>
					</div>
					<div
						class="input__wrap input__wrap-comment {i == 0 &&
							'hidden'}"
					>
						<input
							type="text"
							class="phone__comment"
							on:input={() => ($isNewDataChanged = true)}
							bind:value={data.newData.Phone[i]["Comment"]}
							maxlength={data.maxlength ? data.maxlength : 100}
						/>
						<span
							class={data.newData.Phone[i]["Comment"]
								? "active"
								: ""}>Комментарий</span
						>
					</div>
				{/if}

				{#if data.phones.length < 2}
					<button
						type="button"
						class="form__add"
						on:click={() => add2()}
						><i class="fas fa-times" /></button
					>
				{:else}
					{#if !data.phones[i].toDelete}
						<button
							type="button"
							class="form__remove"
							on:click={() => remove(i)}
							><span><i class="fas fa-times" /></span></button
						>
					{:else}
						<button
							type="button"
							class="form__restore"
							on:click={() => restore(i)}
							><span><i class="fas fa-check" /></span></button
						>
					{/if}
					{#if data.phones.length == i + 1}
						<button
							type="button"
							class="form__add"
							on:click={() => add2()}
							><i class="fas fa-times" /></button
						>
					{:else}
						<div class="form__blank" />
					{/if}
				{/if}
			</div>
		{/each}
	</div>
{/if}

<style lang="scss">
	.input__wrap {
		&:first-child {
			margin: 0 16px 0 0;
		}
		&-comment {
			flex-grow: 1;
			// &.hidden {
			// 	opacity: 0;
			// 	cursor: default;
			// }
		}

		@media (max-width: 991px) {
			&:first-child {
				margin: 0 0 16px 0;
			}
			> input {
				width: 100%;
				margin: 0 60px 0 0;
			}
		}
	}

	.phone {
		display: flex;
		flex-direction: column;
		max-width: var(--module-width-1);

		&__comment {
			flex-grow: 1;
		}

		&__row {
			margin: 0 0 16px 0;
			display: flex;
			&:last-child {
				margin: 0;
			}

			&.deleted {
				.input__wrap {
					> input {
						text-decoration: line-through;
						color: var(--color-4) !important;
					}
					> span {
						color: var(--color-4) !important;
					}
				}
			}

			@media (max-width: 991px) {
				position: relative;
				flex-direction: column;
			}
		}
	}
</style>
